import React, { useState, useContext, useEffect } from 'react';
import { FormItem, Button, FormContext } from '@digital/ui';
import { Icon } from 'antd';
import Upload, { UploadProps } from 'antd/lib/upload';

export default (props: {
  fileName?: string;
  accept?: string;
  hasFile: boolean;
  label?: string;
  url?: string;
  disabled?: boolean;
  id: string;
  selectedItem?: any;
}) => {
  const { fileName, hasFile, accept, label, url, disabled, id, selectedItem } = props;
  const [file, setFile] = useState();
  const [disabledItem, setDisabledItem] = useState<boolean>(false);
  const buttonLabel = label ? label : 'Adicionar ou trocar o arquivo';
  const { formProps } = useContext(FormContext);
  useEffect(() => {
    setDisabledItem(disabled != undefined && disabled == true ? true : false);
    fileName && setFile([{ uid: '1', name: fileName, url: url }]);
    let remove = !hasFile;
    if (remove) {
      setFile([]);
      formProps && formProps.setFieldValue('formData', null);
    }
  }, [fileName, hasFile, selectedItem]);

  const uploadProps: UploadProps = {
    action: '',
    multiple: false,
    type: 'select',
    accept: accept ? accept : '.xlsx, .xls, .png, .doc, .docx, .ppt, .pptx,.txt,.pdf',
    onRemove: _ => {
      setFile([]);
      formProps && formProps.setFieldValue('formData', null);
    },
    beforeUpload: file => {
      setFile([
        {
          uid: '1',
          name: file.name,
        },
      ]);
      formProps && formProps.setFieldValue('formData', file);
      return false;
    },
    headers: {
      authorization: 'authorization-text',
    },
  };

  return (
    <FormItem name="file" span={12}>
      <Upload
        disabled={disabledItem}
        name="file" {...uploadProps}
        id={id}
        fileList={file}>
        <Button>
          <Icon type="upload" /> {buttonLabel}
        </Button>
      </Upload>
    </FormItem >
  );
};
